var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.ready && _vm.product != null
    ? _c(
        "div",
        { staticClass: "lazy-product-card flex flex-1" },
        [
          _c("product-card", {
            staticClass: "flex-1",
            attrs: {
              variants: _vm.product.variants,
              title: _vm.product.name,
              "is-top": _vm.product.is_top,
              description:
                _vm.product.introduction && _vm.product.introduction != ""
                  ? _vm.product.introduction
                  : _vm.product.description,
              media: _vm.product.media,
              link: "/product/" + _vm.product.slug
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }